export default __webpack_public_path__ + "static/media/Ballroll_00225.f605c25b.png";